import config from '@/config'
import { useMemo } from 'react'
import { useLocale } from './useLocale'

export const useGuideUrl = (relativePath?: string) => {
  const locale = useLocale()
  const isLocalEnv = useMemo(() => config.env === 'local', [])

  const url = useMemo(() => {
    if (!relativePath) return null

    const origin = isLocalEnv ? 'http://localhost:3000' : document.location.origin
    const localePath = locale === 'en' ? '' : `${locale}/`

    return `${origin}${config.guideBasePath}${localePath}docs${relativePath}`
  }, [relativePath, locale, isLocalEnv])

  return url
}
